'use strict';exports.__esModule = true;var _kebabCase = require('lodash/kebabCase');var _kebabCase2 = _interopRequireDefault(_kebabCase);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _neighborhoodsMap = require('./neighborhoods-map.json');var _neighborhoodsMap2 = _interopRequireDefault(_neighborhoodsMap);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getNeighborhoods = function getNeighborhoods(cityKey) {var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'he';var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'homes';var optionType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'buy';
  if (!cityKey) {
    return [];
  }
  var cityData = _neighborhoodsMap2.default[cityKey];
  if (!cityData) {
    return [];
  }
  var neighborhoodsKeys = Object.keys(cityData);
  return Object.values(cityData).map(function (item, idx) {return {
      url: '' + location + (optionType ? '/' + optionType : '') + '/' + cityKey + '/' + neighborhoodsKeys[idx],
      tag: neighborhoodsKeys[idx],
      name: item[locale] || item.en };});

};exports.default =

getNeighborhoods;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/neighborhoods/findNeighborhoodNames.js
// module id = 3138
// module chunks = 0